module.exports = __webpack_public_path__ + "media/components/src/assets/images/image_text2/3-6a122c4d2336bea09549ba50f296649f.jpg";